import _ from 'lodash/fp';
import React from 'react';

export function *makeStream(items) {
  let i = 0;

  for (;;) {
    yield items[i];
    i = (i + 1) % items.length;
  }
}

export class StreamManager {
  constructor() {
    this.iterators = {};
  }

  setIterators(its) {
    Object.assign(this.iterators, its);
  }

  iteratorFor(name) {
    return this.iterators[name];
  }

  next(name) {
    return this.iterators[name].next();
  }

  makeChannelStreams(channel) {
    let channelStr = (channel) => {
      const str = channel.toString();
      let zeros = 3 - str.length;
      // return '-' + _.range(0, zeros).map(() => '0').join('') + str;
      return _.range(0, zeros).map(() => '0').join('') + str;
    };

    const iterators = _.flow(
      _.pick(['poster', 'layout', 'shortName', 'name', 'channel']),
      _.update('poster', (src) => <img src={src} />),
      _.update('channel', channelStr),
      _.mapValues((x) => makeStream([x]))
    )(channel);

    this.setIterators(iterators);
  }
}



// WEBPACK FOOTER //
// ./src/utils/Streams.js